import angular from "angular";
import template from "./instructor-event.html";
import InstructorEventController from "./instructor-event.controller";
import {
  toHoursAndMinutes,
  timeStringToDate,
} from "../../../common/helpers/time";
function getEvent(EventsModel, $stateParams) {
  return EventsModel.show($stateParams.eventId).then((response) => {
    const durationParts = toHoursAndMinutes(response.event.duration).split(":");
    response.event.location = angular.fromJson(response.event.location);
    response.event.date = new Date(response.event.date);
    response.event.time = timeStringToDate(response.event.time);
    response.event.duration = {};
    response.event.duration.hours = durationParts[0];
    response.event.duration.minutes = durationParts[1];

    return response.event;
  });
}
getEvent.$inject = ["EventsModel", "$stateParams"];

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.instructor.dashboard.event", {
    url: "/event/:eventId",
    template: template,
    controller: InstructorEventController,
    controllerAs: "vm",
    resolve: {
      event: getEvent,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.instructor,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("instructor.dashboard.event", [])
  .config(config)
  .controller("InstructorEventController", InstructorEventController);
